import A from './types';

const initialState = {};

const reducer = (state, action) => {
  if (action.type !== A.PLACE_LOADED) {
    return null;
  }

  const id = action.meta;

  if (action.error) {
    return {[id]: {error: action.error}};
  }

  if (action.pending) {
    return {[id]: {pending: true}};
  }

  return {[id]: {data: action.payload}};
};

export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/places/reducer.js